import { useCallback } from "react"
import { useMutation } from "urql"

import "../graphql/entityLock.mutation"

import type { HeartbeatResult } from "../types"

import type {
  EntityLockInput,
  HeartbeatEntityLockMutation,
  HeartbeatEntityLockMutationVariables,
} from "@/graphql/codegen/graphql"
import { HeartbeatEntityLockDocument } from "@/graphql/codegen/graphql"

export interface UseHeartbeatEntityLockReturn {
  heartbeat: (input: EntityLockInput) => Promise<HeartbeatResult>
  isHeartbeating: boolean
}

export const useHeartbeatEntityLock = (): UseHeartbeatEntityLockReturn => {
  const [{ fetching }, executeMutation] = useMutation<
    HeartbeatEntityLockMutation,
    HeartbeatEntityLockMutationVariables
  >(HeartbeatEntityLockDocument)

  const heartbeat = useCallback(
    async (input: EntityLockInput): Promise<HeartbeatResult> => {
      const { data, error } = await executeMutation({ input })
      if (error) return { ok: false, isTransportError: true }
      if (data?.entityLock.heartbeat.__typename === "HeartbeatEntityLockSuccess") return { ok: true }
      return { ok: false, isTransportError: false }
    },
    [executeMutation]
  )

  return { heartbeat, isHeartbeating: fetching }
}
